import { Avatar, UserUpdateResource } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";

interface Props {
	speaker: UserUpdateResource;
}

const CardContentWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Infos = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: ${({ theme }) => theme.spacing(4)};
	width: 100%;
`;

const Info = styled.div`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	color: ${({ theme }) => theme.colors.palette.grey[50]};
`;

const Name = styled.span`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	font-size: ${({ theme }) => theme.fonts.sizes.large};
`;

const StyledAvatar = styled(Avatar)`
	width: 90px;
	height: 90px;
`;

export const EventSpeaker: FC<Props> = ({ speaker }) => {
	return (
		<CardContentWrapper>
			<StyledAvatar image={speaker.image} />
			<Infos>
				<Name>{speaker.name}</Name>
				{speaker.position && <Info>{speaker.position}</Info>}
				{speaker.company && <Info>{speaker.company}</Info>}
			</Infos>
		</CardContentWrapper>
	);
};
